import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpService } from './http.service';

@Injectable()
export class ExternalCaseService {

	private baseUrl = environment.serviceBaseUrl + '/external-case';

	constructor(private http: HttpService) { }

	search(searchObj: any, page: number, size: number): Observable<any> {
		return this.http.post<any>(
			this.baseUrl + '/search?page=' + page + '&size=' + size,
			searchObj
		);
	}

	getById(id: number): Observable<any> {
		return this.http.get<any>(this.baseUrl + '/get/' + id);
	}

	add(obj: any): Observable<any> {
		return this.http.post<any>(this.baseUrl + '/add', obj);
	}

	update(obj: any): Observable<any> {
		return this.http.post<any>(this.baseUrl + '/update', obj);
	}

	delete(id: number): Observable<any> {
		return this.http.delete<any>(this.baseUrl + '/delete/' + id);
	}

	getCalendarEntries(isExtended: boolean): Observable<any> {
		return this.http.get<any>(this.baseUrl + '/calendar?isExtended=' + isExtended);
	}
}
